import { render, staticRenderFns } from "./UserMyPurchasesPrepaidPackages.vue?vue&type=template&id=24d2a4fe&"
import script from "./UserMyPurchasesPrepaidPackages.vue?vue&type=script&lang=js&"
export * from "./UserMyPurchasesPrepaidPackages.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports